import React from 'react'
import { useSelector } from 'react-redux'
import { RootReducer } from '../../redux/rootReducer'
import CaptchaPage from '../organisms/CaptchaPage'
import LanguageSelector from './LanguageSelector'

interface Props {
  children: JSX.Element
}

const CaptchaGate = ({ children }: Props): JSX.Element => {
  const authState = useSelector((state: RootReducer) => state.authReducer.authorizedState)
  const captchaRequired = useSelector((state: RootReducer) => Boolean(state.userDataReducer.captcha_required))

  if (authState === 'authorized' && captchaRequired) {
    return (
      <>
        <LanguageSelector />
        <CaptchaPage />
      </>
    )
  }

  return children
}

export default CaptchaGate
